































































import { Vue, Component } from 'vue-property-decorator';
import { Toast } from 'vant';
import { saveinfo } from '../api';
import { isWeiXin } from '@/common/ts/common';
import qs from 'qs';

Vue.use(Toast);

@Component
export default class Active extends Vue {
  name: string = '';
  phone: string = '';
  addr: string = '';
  contetext: string = '';
  isclick: boolean = false;

  mounted() {
    if (!isWeiXin() && !window.udid) {
      Toast('请在微信或者App中打开，参与活动');
      return false;
    }
    if (window.localStorage.getItem('unionid') === null && isWeiXin()) {
      this.WechatLogin();
      return false;
    } else if (window.udid) {
      this.AppLogin();
    }
  }
  getpublic() {
    if (this.isclick) {
      return false;
    }
    this.isclick = true;
    if (!this.name) {
      Toast('请填写您的姓名！');
      this.isclick = false;
      return false;
    } else if (!/^1[345789][0-9]{9}$/.test(this.phone)) {
      Toast('电话号码格式错误！');
      this.isclick = false;
      return false;
    } else if (!this.addr) {
      Toast('请输入您居住的小区名称');
      this.isclick = false;
      return false;
    }
    if (!isWeiXin() && !window.udid) {
      this.isclick = false;
      Toast('请在微信或者App中打开，参与活动');
      return false;
    }
    if (window.localStorage.getItem('unionid') === null && isWeiXin()) {
      this.isclick = false;
      this.WechatLogin();
      return false;
    } else if (window.udid) {
      this.isclick = false;
      this.AppLogin();
    }
    const data = {
      name: this.name,
      phone: this.phone,
      addr: this.addr,
      contetext: this.contetext,
      unionid: window.localStorage.getItem('unionid'),
    };
    saveinfo(data).then((res: any) => {
      this.isclick = false;
      if (res.code === 200) {
        Toast.success(res.msg);
        setTimeout(() => {
          window.location.reload();
        }, 2000);
      } else {
        Toast.fail(res.msg);
      }
    });
  }
  AppLogin() {
    const token = window.gettoken();
    if (token === 'null' || !token) {
      if (parseFloat(window.version) >= 4.5) {
        window.handleMessage('{"action":"mUserLogin","data":""}');
      } else {
        window.location.href = 'client:logout';
      }
      return;
    }
  }

  WechatLogin() {
    const { code, source } = qs.parse(location.search, {
      ignoreQueryPrefix: true,
    });
    if (isWeiXin() && !code) {
      const appId = 'wx1949ed4a473b87ed';
      location.href = `https://activity.cqcb.com/wechat-auth.html?appId=${appId}&backUrl=${encodeURIComponent(
        location.href,
      )}`;
    }
  }
}
